import React from "react"
import './index.css';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Form from 'react-bootstrap/Form'
import CurrencyBoard from './currencyBoard.js';
import Clock from 'react-live-clock';
import Steamers from './steamers.js';
import Drifters from './drifters.js'
import axios from 'axios';
import store from "./store/index";
import moment from 'moment';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import { Auth } from "aws-amplify";
import DatePicker from './components/UI/DatePicker'
import { passDateToString } from './util/date/date-utils'
import { currentDateStr } from './util/date/date-utils'
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import Dropdown from 'react-bootstrap/Dropdown';
import BfResult from './bfResult'
import { connect } from "react-redux"
import { UPDATE_TOKEN } from "./constants/action-types";
import { updateCurrentBets, updateDisplayConfirmBox, updateLoginToken, updateRefreshSteamerDrifter } from "./actions";
import { API_BF_FUND, getLoginToken, clear, getCurrencySymbol, getUserName } from "./constants/utils";
import SteamerDrifterFilterForm from "./SteamerDrifterFilterForm.jsx";
import { Col, Row, Container } from "react-bootstrap";
import { SettingsCell } from "@material-ui/icons";
import horseIcon from './assets/horse_icon.jpg';
import harnessIcon from './assets/harness_icon.jpg';



const API3 = 'https://rpmapi.makebettinggreat.com/v1/horse/steamer-drifter/all';

function download_csv(csv, filename) {
  var csvFile;
  var downloadLink;

  // CSV FILE
  csvFile = new Blob([csv], { type: "text/csv" });

  // Download link
  downloadLink = document.createElement("a");

  // File name
  downloadLink.download = filename;

  // We have to create a link to the file
  downloadLink.href = window.URL.createObjectURL(csvFile);

  // Make sure that the link is not displayed
  downloadLink.style.display = "none";

  // Add the link to your DOM
  document.body.appendChild(downloadLink);

  // Lanzamos
  downloadLink.click();
}

function export_table_to_csv(html, filename) {
  var csv = [];
  var rows = html.querySelectorAll("table tr");
  for (var i = 0; i < rows.length; i++) {
    var row = [], cols = rows[i].querySelectorAll("td, th");
    for (var j = 0; j < cols.length; j++) {
      const col = cols[j];
      if (col.getAttribute('data-skip-export') === 'true') continue;
      const exportVal = col.getAttribute('data-export');
      row.push(exportVal !== null ? exportVal : col.innerText);
    }
    csv.push(row.join(","));
  }
  // Download CSV
  download_csv(csv.join("\n"), filename);
}

function reloadPage() {
  //console.log("Reloading the page");
  window.location.reload();
}

function downloadTable() {
  //console.log("Download table to excel");
}
const postRequestPara = {
  "option": 1,
  "time": "20190408-14:15:40",
  "steamerMinPrice": 1.00,
  "steamerMaxPrice": 100.00,
  "drifterMinPrice": 1.00,
  "drifterMaxPrice": 100.00,
  "minVolume": 1,
  "countries": ["GB", "IL"]
}

const style1 = {
  color: '#92f7f9',
  textAlign: 'center',
  width: '100%',
}
const back1 = {
  background: '#3b7d35',
  alignItems: 'center',
  height: '45px'
}

const navBarStyle = {
  height: '60px',
  alignContent: 'center'

}

const gbCountries = ["GB", "IE"];
const anzCountries = ["AU", "NZ"];
const othCountries = ["ZA", "US", "SE", "DE", "FR"]


class ControlledTabs extends React.Component {

  timer = null;

  constructor(props, context) {
    super(props, context);
    this.state = {
      key: 'RacesNRunners',
      steamers: [],
      drifters: [],
      userInfo: "",
      selectedDate: currentDateStr(),
      exactT0InLocal: "",
      displayTicks: false,
      displayResult: 'Price Movement',
      bfFunds: {},
      displayConfirmBox: true,
      showFavoriteOnly: false,
      loading: false,
      refreshSteamerDrifter: false,
      showCountryTotal: false

    };
  }

  getValueForJson(obj, k) {
    const value = obj[k];
    if (value === null || value === undefined || value === "") {
      return '""'; // leave blank in CSV
    }
    if (k == "raceTime") {
      const raceTimeValue = obj["raceTime"];
      if (raceTimeValue && raceTimeValue.includes("-")) {
        const [datePart, timePart] = raceTimeValue.split("-");
        console.log("vivek123" + `${datePart.slice(0, 4)}/${datePart.slice(4, 6)}/${datePart.slice(6, 8)}`)
        return [`${datePart.slice(0, 4)}/${datePart.slice(4, 6)}/${datePart.slice(6, 8)}`, timePart];
      }
    }
    if (k == "movementPercentage") {
      const value = obj["movementPercentage"];
      return [(value < 0 ? 'Steamer' : 'Drifter'), Math.abs(value)];
    }
    if(k === 'favourite'){
      return value ? "Yes" : "No";
    }
    return `"${String(value).replace(/"/g, '""')}"`
  }

  convertToCSV(objArray) {
    try {
      const array = Array.isArray(objArray) ? objArray : JSON.parse(objArray);
      const headresOrdered = ["raceTime", "bfMarketName", "raceVenue", "country", "runnerName", "favourite", "priceAtTime", "currentPrice", "movementPercentage", "winnerIndicator"];
      const rows = array.map((obj, index) => {
        const rowValues = headresOrdered.map(header => this.getValueForJson(obj, header, index))
        return [index + 1, ...rowValues].join(",");
      }
      );
      const headers2 = ["S.No", "Date", "Time", "Market Name", "Race Venue", "Country", "Runner Name", "Favourite", 
        "Price At Time(" + (this.state.exactT0InLocal.replaceAll("At","")) +")", 
        "Current Price", "Steamer/Drifter", "Movement Percentage", "Result"]
      return [headers2.join(","), ...rows].join("\n");
    } catch (error) {
      console.log("error converting to csv: " + error)
      return "";
    }
  }

  clickEvent() {
    const marketName = document.querySelector("#selectedMarketDetails") !== null ? document.querySelector("#selectedMarketDetails").textContent : null;
    const currentTab = this.state.key;
    if (currentTab === 'RacesNRunners' && marketName !== null) {
      var html = document.querySelector("#runner_Odds_Table");
      export_table_to_csv(html, marketName + ".csv");
    } else if (currentTab === 'stemsNDriftANZ') {
      const steamer = this.filterByCountries(this.state.steamers['stemsNDriftANZ'], true, anzCountries)
      download_csv(this.convertToCSV(steamer), "Steamer_Drifter_ANZ_" + this.state.selectedDate + ".csv")
    } else if (currentTab === 'stemsNDriftUK') {
      const steamer = this.filterByCountries(this.state.steamers['stemsNDriftUK'], true, gbCountries)
      download_csv(this.convertToCSV(steamer), "Steamer_Drifter_UK_" + this.state.selectedDate + ".csv")
    } else if (currentTab === 'stemsNDriftOTH') {
      const steamer = this.filterByCountries(this.state.steamers['stemsNDriftOTH'], true, othCountries)
      download_csv(this.convertToCSV(steamer), "Steamer_Drifter_OTH_" + this.state.selectedDate + ".csv")
    } else {
      alert("Please load desired market odds before exporting.")
    }
  }

  componentDidUpdate(prevProps) {
    console.log("componentDidUpdate called in ControlledTabs:" + this.props.settingChangeVersion);
    if(prevProps.settingChangeVersion !== this.props.settingChangeVersion){
       this.testing()
    }
    if (prevProps.refreshSteamerDrifter !== this.props.refreshSteamerDrifter) {
      //console.log("✅ Prop 'refreshSteamerDrifter' has changed!");
      if (this.timer != null) {
        clearInterval(this.timer);
      }
      if (this.props.refreshSteamerDrifter) {
        this.timer = setInterval(() => {
          //console.log("Recursively right table is loading....");
          this.testing()
        }, 30000)
      }
    }
  }

  handleBetfairLogout = () => {
    clear();
    store.dispatch(updateLoginToken(null));
  }

  handleConfirmOption = (event) => {
    //console.log("handleConfirmOption: " + event.target.checked)
    this.setState({
      displayConfirmBox: event.target.checked
    })
    store.dispatch(updateDisplayConfirmBox(event.target.checked))
  }

  handleRefreshOption = (event) => {
    //console.log("handleConfirmOption: " + event.target.checked)
    this.setState({
      refreshSteamerDrifter: event.target.checked
    })
    store.dispatch(updateRefreshSteamerDrifter(event.target.checked))
  }

  selectedDateChangeHandler = (event) => {
    const newDate = passDateToString(event);
    //console.log(newDate);
    this.setState({
      selectedDate: newDate
    }, () => this.reloadView());
  }

  displayTickedCheckChangedHandler = (value) => {
    //console.log("displayTickedCheckChangedHandler: " + value)
    this.setState({
      displayTicks: value
    })
  }
  handleSelect = (evt) => {
    this.setState({
      displayResult: evt
    })
  }

  reloadView() {
    if (this.timer != null) {
      clearInterval(this.timer);
    }
    this.testing();
    //this.timer = setInterval(() => {
    //console.log("Recursively right table is loading....");
    // this.testing()
    //}, 120000)
  }

  convertHHMMToMinutes(timeInHHMM) {
    var hours = parseInt(timeInHHMM.substring(0, 2))
    var mints = parseInt(timeInHHMM.substring(3, 5))
    return (hours * 60 + mints)
  }

  testing() {
    let selectedTab = this.state.key;
    let currentStreamer = this.state.steamers;
    let currentDrifter = this.state.drifters;
    //reset only current tab data
    currentStreamer[selectedTab] = [];
    currentDrifter[selectedTab] = [];
    this.setState({ loading: true, steamers: currentStreamer, drifters: currentDrifter })
    this.mounted = true;

    //console.log("Selected tab is : " + selectedTab);
    let diff = store.getState().t0Settings.diffgb;
    let exactTimeSettingsT0 = store.getState().exactTimeSettings.t0;
    let option = ""
    if (selectedTab === "stemsNDriftUK") {
      postRequestPara.countries = gbCountries;
      diff = store.getState().t0Settings.diffgb;
      exactTimeSettingsT0 = store.getState().exactTimeSettings.t0gb;
      option = store.getState().t0Settings.optiongb;
    } else if (selectedTab === "stemsNDriftANZ") {
      postRequestPara.countries = anzCountries
      diff = store.getState().t0Settings.diffanz;
      exactTimeSettingsT0 = store.getState().exactTimeSettings.t0anz;
      option = store.getState().t0Settings.optionanz;
    } else if (selectedTab === "stemsNDriftOTH") {
      postRequestPara.countries = othCountries
      diff = store.getState().t0Settings.diffoth;
      exactTimeSettingsT0 = store.getState().exactTimeSettings.t0oth;
      option = store.getState().t0Settings.optionoth;
    }
    postRequestPara.steamerMinPrice = store.getState().StearmerDrifterSettings.STEAMER_MIN_PRICE
    postRequestPara.steamerMaxPrice = store.getState().StearmerDrifterSettings.STEAMER_MAX_PRICE
    postRequestPara.drifterMinPrice = store.getState().StearmerDrifterSettings.DRIFTER_MIN_PRICE
    postRequestPara.drifterMaxPrice = store.getState().StearmerDrifterSettings.DRIFTER_MAX_PRICE
    postRequestPara.minVolume = store.getState().StearmerDrifterSettings.MIN_VOLUME
    postRequestPara.originalOption = option
    postRequestPara.favoritesOnly = this.props.isFav;

    let timestamp = moment().tz("Etc/GMT")
    if (option != "exact" && diff) {
      //console.log("exact seelctio nnn: " + store.getState().t0Settings.diff);
      let [hours, minutes] = diff.split(":").map(Number);
      timestamp = timestamp.subtract(hours, "hours").subtract(minutes, "minutes");
      //console.log("Result of API 3 time reduced :: " + timestamp.format("YYYYMMDD-HH:mm:ss")); //"time": "20190408-14:15:40",
    } else {
      timestamp = moment(this.state.selectedDate + "-" + exactTimeSettingsT0, 'YYYYMMDD-HH:mm');
      //if (timestamp > moment()) timestamp = timestamp.subtract(1, 'days');
      //console.log("Result of API 3 time :: " + timestamp.format("YYYYMMDD-HH:mm:ss"))
    }

    postRequestPara.time = timestamp.format("YYYYMMDD-HH:mm:ss")
    let [hours, minutes] = diff.split(":").map(Number);
    postRequestPara.diff = hours * 60 + minutes;
    postRequestPara.dateYYYYMMDD = this.state.selectedDate;
    //console.log("Result of API 3 countries :: " + postRequestPara.countries);
    //console.log("Result of API 3 time :: " + timestamp.format("YYYYMMDD-HH:mm:ss")); //"time": "20190408-14:15:40",
    this.setState({
      exactT0InLocal: option === 'diff' ?
        (this.convertHHMMToMinutes(diff) + ' minutes before') :
        ('At ' + timestamp.add('minutes', store.getState().localTimeOffSetToGmt).format('HH:mm')),
    })

    this.serverRequest =
      axios.post(API3, postRequestPara)
        .then((res) => {
          //console.log("Result of API 3 ::" + res.data)
          window.response12 = res.data
          //set only current tab data
          currentStreamer[selectedTab] = [...res.data.steamersPast || [], ...res.data.steamers || []];
          currentDrifter[selectedTab] = [...res.data.driftersPast || [], ...res.data.drifters || []];
          this.setState({
            steamers: currentStreamer,
            drifters: currentDrifter,
            loading: false
          })
        },
          (error) => {
            //console.log("Result of API 3 returns Error!!!" + error)
            this.setState({
              loading: false
            })
          });
  }



  componentWillUnmount() {
    this.mounted = false;
  }

  async componentDidMount() {

    if (this.state.key != null && (this.state.key === "stemsNDriftUK" || this.state.key === "stemsNDriftANZ" || this.state.key === "stemsNDriftOTH")) {
      this.reloadView()
    }

    try {

      this.fundTimer = setInterval(() => {
        this.requestBfFundInfo()
      }, 5000)


      const info = await Auth.currentUserInfo()
      //console.log('Returned info: ', info)
      this.setState({
        userInfo: info.attributes.email

      })
    } catch (e) {
      //console.log("Error");
      //alert(e.message);
    }
  }

  requestBfFundInfo = () => {
    if (!getLoginToken() || getLoginToken() === "") {
      return;
    }
    const postRequestPara = {
      "ssoid": getLoginToken()
    }
    axios.post(API_BF_FUND, postRequestPara)
      .then((res) => {
        //console.log("requestBfFundInfo. Result of API Winner ::" + res.data)
        const currentState = { ...this.state }
        currentState.bfFunds = res.data
        this.setState(currentState)
      },
        (error) => {
          //console.log("requestBfFundInfo. Error occurred when reading Winner info")
        });
  }


  getBfLogoutButton = () => {
    return <Button
      onClick={this.handleBetfairLogout} variant="contained" color="secondary">
      Bf Logout
    </Button>
  }

  getCurrencySymbol = () => {
    try {
      return getCurrencySymbol(this.state.bfFunds.accountDetailsResponse.currencyCode);
    } catch (error) {
      //console.log("error formatting currency symbol")
    }
    return "";
  }

  decimalPlace = (num) => {
    try {
      return (Math.round(num * 100) / 100).toFixed(2);
    } catch (error) {
      return "Fetching";
    }
  }

  getFundInformation = () => {
    return getUserName() && this.state.bfFunds && this.state.bfFunds.fundsResponse ?
      'Balance:  ' +
      this.getCurrencySymbol() +
      this.decimalPlace(this.state.bfFunds.fundsResponse.availableToBetBalance - this.state.bfFunds.fundsResponse.exposure) +
      '/' +
      this.decimalPlace(this.state.bfFunds.fundsResponse.availableToBetBalance)
      :
      null
  }

  handleLogout = async event => {
    await Auth.signOut();
    this.props.userHasAuthenticated(false);
    this.handleBetfairLogout();
  }

  tabOnSelectHandler = key => {
    //console.log("tabOnSelectHandler called. " + key)
    this.setState({ key: key }, () => {
      if (key === "stemsNDriftUK" || key === "stemsNDriftANZ" || key === "stemsNDriftOTH") {
        //reload only if data not present
        if (!this.state.steamers[key])
          this.reloadView(key);
      }
    });
  }

  filterByCountries = (items, isStreamerDrifter, countries) => {
    //console.log("steamerRange: " + this.props.steamerRange);
    //console.log("drifterRange: " + this.props.drifterRange);
    if (!items || items.length === 0) return [];
    return items.filter(i => countries.includes(i.country))
      .filter(item =>
        isStreamerDrifter ? (Math.abs(item.movementPercentage) >= this.props.steamerLowerLimit) :
          Math.abs(item.movementPercentage) >= this.props.drifterLowerLimit)
      .filter(item =>
        isStreamerDrifter ? (Math.abs(item.movementPercentage) <= this.props.steamerUpperLimit) :
          Math.abs(item.movementPercentage) <= this.props.drifterUpperLimit)
      .filter(item => this.props.isCompleted ? true : moment.utc(item.raceTime, "YYYYMMDD-HH:mm", "Etc/GMT").isAfter(moment.tz("Etc/GMT")))
      .filter(item => this.props.isFav ? item.favourite === true : true)
      .filter(item => this.props.includeHarness ? true : !(item.bfMarketName.includes("Pace") || item.bfMarketName.includes("Trot")));
  }
  render() {
    return (
      <div >
        <nav style={navBarStyle} class="navbar navbar-dark bg-dark">
          <div class="timeStyle box2">Welcome {this.state.userInfo}</div>
          <div class="timeStyle box2"><h5 style={style1}>Welcome to Racing Price Monitor</h5></div>
          <div class="timeStyle box2" style={{ display: "flex", fontSize: "14px" }}>
            <div style={{ margin: "15px", padding: "5px" }}>
              {this.getFundInformation()}
            </div>
            <div style={{ margin: "15px", padding: "5px" }}>
              {getUserName() ? 'User:  ' + getUserName() : null}
              {'    '}
            </div>
            <div style={{ margin: "5px", padding: "5px" }}>
              {getLoginToken() ? this.getBfLogoutButton() : null}
            </div>
            <div style={{ margin: "5px", padding: "5px", display: "flex", alignItems: "center" }}>
              <a href="https://winningmore.com/Australia/" target="_blank" rel="noopener noreferrer" style={{ color: "#fff", textDecoration: "none", fontWeight: "bold", fontSize: "14px", whiteSpace: "nowrap", background: "#e53935", padding: "6px 14px", borderRadius: "4px", boxShadow: "0 2px 6px rgba(0,0,0,0.4)", letterSpacing: "0.5px" }}>&#9654; Watch Aus Racing</a>
            </div>
          </div>
          <div class="timeStyle box2">
            <Button variant="contained" color="primary" onClick={this.handleLogout}>
              Logout
              <Icon >logout</Icon>
            </Button>
          </div>
        </nav>
        <div style={back1}>
          <div class="timeStyle box2">
            <Button size="small" variant="contained" color="primary" onClick={() => this.props.openSideBar(true)}>
              settings
              <Icon >settings</Icon>
            </Button>
          </div>
          <div class="timeStyle box2">
            <Button size="small" variant="contained" color="primary" id="downloadBtn" onClick={() => this.clickEvent()}>
              export
              <Icon >arrow_downward</Icon>
            </Button>
          </div>
          <div class="timeStyle box2">
            <Button size="small" variant="contained" color="primary" onClick={() => this.reloadView()}>
              refresh
              <Icon >refresh</Icon>
            </Button>
          </div>
          <div class="timeStyle box2">
            <Button size="small" variant="contained" color="primary" href="https://winningmore.com/manual.htm" target="_blank">
              user guide
              <Icon >menu</Icon>
            </Button>
          </div>
          <div class="timeStyle box2" style={{ fontSize: '14px' }}>
            <DatePicker selectedDate={this.state.selectedDate} selectedDateChanged={this.selectedDateChangeHandler} />
          </div>
          <div class="timeStyle box2" style={{ marginLeft: '90px', color: 'black', fontSize: '14px' }}>
            <BootstrapSwitchButton key="displayTicksCheckBox"
              checked={this.state.displayTicks}
              id="displayTicksCheckBox"
              size="sm"
              width={119}
              onlabel="Hide Ticks"
              offlabel="Show Ticks"
              onChange={(checked) => { this.displayTickedCheckChangedHandler(checked) }}
            />
          </div>
          <div className="timeStyle box2" onSelect={this.selectDropDown}
            style={{ marginLeft: '0px', color: 'black', fontSize: '14px' }}>
            <Dropdown title='Select Value' onSelect={this.handleSelect}>
              <Dropdown.Toggle style={{ backgroundColor: '#303f9f' }}>
                {this.state.displayResult}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item eventKey="Price Movement">Price Movement</Dropdown.Item>
                <Dropdown.Item eventKey="Market Movement">Market Movement</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="timeStyle box2" onSelect={this.selectDropDown}
            style={{ marginLeft: '20px', color: 'black', fontSize: '14px' }}>
            <Form class="d-flex align-items-center gap-3">
              <Form.Check
                type='checkbox'
                checked={this.state.displayConfirmBox}
                label={'Show Confirm'}
                style={{ display: 'inline-block', marginRight: '15px' }}
                onChange={(checked) => { this.handleConfirmOption(checked) }}
              />

            </Form>
          </div>
          <div className="timeStyle box2"
            style={{ marginLeft: '20px', color: 'black', fontSize: '14px' }}>
            <Form class="d-flex align-items-center gap-3">
              <Form.Check
                type='checkbox'
                checked={this.state.refreshSteamerDrifter}
                label={'Reload Steamer/Drifter'}
                style={{ display: 'inline-block', marginRight: '15px' }}
                onChange={(checked) => { this.handleRefreshOption(checked) }}
              />
              <a
                href={`https://rpmapi.makebettinggreat.com/v1/horse/ai-report/${this.state.selectedDate}/download`}
                download={`Daily-AI-Winners-${this.state.selectedDate.replace(/-/g, '')}`}
                style={{ display: 'inline-block', fontSize: '14px', color: '#ffdd57', fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer', letterSpacing: '0.5px' }}
              >
                Daily AI Winners
              </a>

            </Form>
          </div>
          <div class="timeStyle box3">
            <Button size="small" style={{ fontSize: '0.75em' }} variant="contained" color="primary">
              Time (LOCAL) : <Clock format={'YYYY-MM-DD HH:mm:ss'} ticking={true} />
            </Button>
          </div>
          <div class="timeStyle box3">
            <Button size="small" style={{ fontSize: '0.75em' }} variant="contained" color="secondary">
              Time (UK) : <Clock format={'YYYY-MM-DD HH:mm:ss'} ticking={true} timezone={'Europe/London'} style={{ fontSize: '1.2em' }} />
            </Button>
          </div>
        </div>
        <div class="zstore">
          <Tabs
            id="controlled-tab-example"
            activeKey={this.state.key}
            onSelect={key => this.tabOnSelectHandler(key)}
            mountOnEnter={true}
            unmountOnExit={true}
          >
            <Tab eventKey="RacesNRunners" title="Races and Runners">
              <CurrencyBoard tabSelected={this.state.key} displayTicks={this.state.displayTicks}
                displayResult={this.state.displayResult} selectedDate={this.state.selectedDate} />
            </Tab>
            <Tab eventKey="stemsNDriftUK" title="Steamers and Drifters(UK/Ire)">
              <div>
                <Row className="g-0"> <Col xs={12}><SteamerDrifterFilterForm selectedDate={this.state.selectedDate} /></Col></Row>
                <Row>
                  <Col xs={6}>
                    <Steamers refresh={this.state.key === 'stemsNDriftUK'} array={this.filterByCountries(this.state.steamers['stemsNDriftUK'], true, gbCountries)}
                      t0Time={this.state.exactT0InLocal} loading={this.state.loading} />
                  </Col>
                  <Col xs={6}>
                    <Drifters refresh={this.state.key === 'stemsNDriftUK'} array={this.filterByCountries(this.state.drifters['stemsNDriftUK'], false, gbCountries)}
                      t0Time={this.state.exactT0InLocal} loading={this.state.loading} />
                  </Col>
                </Row>

              </div>

            </Tab>
            <Tab eventKey="stemsNDriftANZ" title="Steamers and Drifters(ANZ)">
              <div>
                <Row className="g-0"> <Col xs={12}><SteamerDrifterFilterForm selectedDate={this.state.selectedDate} /></Col></Row>
                <Row>
                  <Col xs={6}>
                    <Steamers refresh={this.state.key === 'stemsNDriftANZ'} array={this.filterByCountries(this.state.steamers['stemsNDriftANZ'], true, anzCountries)}
                      t0Time={this.state.exactT0InLocal} loading={this.state.loading} />
                  </Col>
                  <Col xs={6}>
                    <Drifters refresh={this.state.key === 'stemsNDriftANZ'} array={this.filterByCountries(this.state.drifters['stemsNDriftANZ'], false, anzCountries)}
                      t0Time={this.state.exactT0InLocal} loading={this.state.loading} />
                  </Col>
                </Row>

              </div>

            </Tab>
            <Tab eventKey="stemsNDriftOTH" title="Steamers and Drifters(OTH)">
              <div>
                <Row className="g-0"> <Col xs={12}><SteamerDrifterFilterForm selectedDate={this.state.selectedDate} /></Col></Row>
                <Row>
                  <Col xs={6}>
                    <Steamers refresh={this.state.key === 'stemsNDriftOTH'} array={this.filterByCountries(this.state.steamers['stemsNDriftOTH'], true, othCountries)}
                      t0Time={this.state.exactT0InLocal} loading={this.state.loading} />
                  </Col>
                  <Col xs={6}>
                    <Drifters refresh={this.state.key === 'stemsNDriftOTH'} array={this.filterByCountries(this.state.drifters['stemsNDriftOTH'], false, othCountries)}
                      t0Time={this.state.exactT0InLocal} loading={this.state.loading} />
                  </Col>
                </Row>
              </div>
            </Tab>
            <Tab eventKey="Unmatched Bets" title="Unmatched">
              <div><BfResult showDateDropDown="false" refreshTime="2000"
                type="current" filterStatus="EXECUTABLE"></BfResult></div>
            </Tab>
            <Tab eventKey="CurrentBets" title="Matched Bets">
              <div><BfResult showDateDropDown="false" refreshTime="3000"
                type="current" filterStatus="EXECUTION_COMPLETE"></BfResult></div>
            </Tab>
            <Tab eventKey="Lapse" title="Lapse Bets">
              <div><BfResult type="cleared"
                showDateDropDown="false" refreshTime="60000"
                filterBetStatus={["VOIDED", "LAPSED", "CANCELLED"]}></BfResult></div>
            </Tab>
            <Tab eventKey="Settled" title="Settled Bets">
              <div><BfResult type="cleared"
                showDateDropDown="true" refreshTime="60000"
                filterBetStatus={["SETTLED"]}></BfResult></div>
            </Tab>
            {this.props.aiRankStats && (() => {
              const s = this.props.aiRankStats
              const useTotal = this.state.showCountryTotal
              const display = useTotal
                ? (s.total && s.total.rank1 ? s.total : null)
                : (s.horseOnly && s.horseOnly.rank1 ? s.horseOnly : (s.total && s.total.rank1 ? s.total : null))
              if (!display || ['FR', 'US'].includes(s.country)) return null
              const labelIcons = useTotal
                ? <><img src={horseIcon} alt="Horse" style={{ width: '20px', height: '20px', marginRight: '2px' }} /><img src={harnessIcon} alt="Harness" style={{ width: '20px', height: '20px', marginRight: '2px' }} /></>
                : (s.horseOnly && s.horseOnly.rank1 ? <img src={horseIcon} alt="Horse" style={{ width: '20px', height: '20px', marginRight: '2px' }} /> : <><img src={horseIcon} alt="Horse" style={{ width: '20px', height: '20px', marginRight: '2px' }} /><img src={harnessIcon} alt="Harness" style={{ width: '20px', height: '20px', marginRight: '2px' }} /></>)
              const label = <span>{labelIcons}({s.country})</span>
              const hasHorseOnly = s.horseOnly && s.horseOnly.rank1
              return (
                <Tab eventKey="__ai_stats__" disabled title={
                  <span style={{ cursor: 'default', fontSize: '15px', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center' }}>
                    <span style={{ color: '#b45309', marginRight: '14px' }}>
                      {label} · {display.totalRaces} Races
                    </span>
                    <span style={{ color: '#166534', background: '#dcfce7', padding: '2px 8px', borderRadius: '4px', marginRight: '8px' }}>
                      Rank 1 · Win {display.rank1.hitPct}% · Avg {display.rank1.avgOdds}
                    </span>
                    <span style={{ color: '#1e40af', background: '#dbeafe', padding: '2px 8px', borderRadius: '4px', marginRight: '8px' }}>
                      Rank 2 · Win {display.rank2.hitPct}% · Avg {display.rank2.avgOdds}
                    </span>
                    <span style={{ color: '#7e22ce', background: '#f3e8ff', padding: '2px 8px', borderRadius: '4px', marginRight: '12px' }}>
                      Rank 3 · Win {display.rank3.hitPct}% · Avg {display.rank3.avgOdds}
                    </span>
                    {hasHorseOnly && s.country === 'AU' && (
                      <label style={{ fontSize: '13px', fontWeight: 'bold', color: '#fff', marginBottom: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', pointerEvents: 'auto', background: '#e67e22', padding: '2px 8px', borderRadius: '4px', border: '1px solid #ca6f1e' }}
                        onClick={e => e.stopPropagation()}>
                        <input
                          type="checkbox"
                          style={{ pointerEvents: 'auto', cursor: 'pointer', width: '14px', height: '14px' }}
                          checked={this.state.showCountryTotal}
                          onChange={e => this.setState({ showCountryTotal: e.target.checked })}
                        />
                        Includes Harness
                      </label>
                    )}
                  </span>
                }></Tab>
              )
            })()}
          </Tabs>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loginToken: state.loginToken,
    aiRankStats: state.aiRankStats,
    isFav: state.streamerDrifterFilterSettings.isFav,
    includeHarness: state.streamerDrifterFilterSettings.includeHarness,
    isCompleted: state.streamerDrifterFilterSettings.isCompleted,
    steamerLowerLimit: state.streamerDrifterFilterSettings.steamerLowerLimit,
    drifterLowerLimit: state.streamerDrifterFilterSettings.drifterLowerLimit,
    steamerUpperLimit: state.streamerDrifterFilterSettings.steamerUpperLimit,
    drifterUpperLimit: state.streamerDrifterFilterSettings.drifterUpperLimit,
    steamerRange: state.streamerDrifterFilterSettings.steamerRange,
    drifterRange: state.streamerDrifterFilterSettings.drifterRange,
    refreshSteamerDrifter: state.refreshSteamerDrifter,
    settingChangeVersion: state.settingChangedVersion,
  }
}


const mapDispatchToProps = dispatch => {
  return {
    setLoginToken: payload =>
      dispatch({ type: UPDATE_TOKEN, payload: payload }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ControlledTabs);
